import PropTypes from 'prop-types';

const StartRecordingIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g fill={fill} fillRule="evenodd">
        <path d="M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0zm0 4.8C13.396 4.8 4.8 13.396 4.8 24S13.396 43.2 24 43.2 43.2 34.604 43.2 24 34.604 4.8 24 4.8z" />
        <circle cx="24" cy="24" r="9.6" />
      </g>
    </svg>
  </div>
);

StartRecordingIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

StartRecordingIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default StartRecordingIcon;
